import draic from '../../Assets/Images/draic.png';
import collegeranker from '../Images/collegeranker.png';
import gdsc from '../Images/gdsc.png';
import xp from '../Images/xphouse.png';
import aces from '../Images/aceslogo.png';
import acm from '../Images/acm.png';

export const ExperiencesData = [
  {
    date: 'Feb-22 Present',
    year: '2021-22',
    position: 'React Developer',
    description:
      'I am currently building their official site with ReactJs along with Onkar Mathapati(Founder of CollegeRanker India) ',
    image: collegeranker,
    align: 0,
    company: 'CollegeRanker India',
    // color: "linear-gradient(135deg, #4285f4, #8b5cf6)",
    color: 'linear-gradient(315deg, #2a2a72aa 0%, #009ffdaa 74%)'
  },

  {
    date: 'Sep-21 Present',
    year: '2021-22',
    position: 'Technical Team Member',
    description:
      'As a part of this amazing community of DRAIC-DYPCOE, I got the chance to create its official website from scratch. I am also learning robotics and creating amazing stuff!',
    image: draic,
    align: 1,
    company: 'DRAIC-DYPCOE',
    color: 'linear-gradient(to right top, #000158aa, #000000aa)'
  },
  {
    date: 'Jan-22 Present',
    year: '2021-22',
    position: 'Technical Coordinator',
    description:
      'Conducted a hands-on virtual event for juniors of web development basics like HTML,CSS, JS and APIs ana an offline event on Backend Development with more than 500+ attendees. ',
    image: gdsc,
    align: 0,
    company: 'GDSC DYPCOE',
    color:
      'linear-gradient(319deg, #91d370aa 0%, #bca0ffaa 37%, #f2cd54aa 100%)'
  },
  {
    date: 'Oct-21 Present',
    year: '2021-22',
    position: 'Publicity Team Member',
    description:
      'I have worked in promotion of content of ACES events in the entire college.',
    image: aces,
    align: 1,
    company: 'ACES-DYPCOE',
    color: 'linear-gradient(45deg, #182b3aaa 0%, #20a4f3aa 74%)'
  },
  {
    date: 'Sep-21 Present',
    year: '2021-22',
    position: 'Founder and Developer',
    description: 'Its a place to share your interview experience',
    image: xp,
    align: 0,
    company: 'Xp-House',
    color: 'linear-gradient(225deg, #fed7aaaa, #fb923caa)'
  },
  {
    date: 'Aug-22 Present',
    year: '2022-23',
    position: 'Web Specialist',
    description:
      'Conducted many events like Hacktoberfest 2022, Info Sessions, etc. Built open source Projects and maintains the official GDSC website. ',
    image: gdsc,
    align: 1,
    company: 'GDSC DYPCOE',
    color: 'linear-gradient(319deg, #91d370aa 0%, #bca0ffaa 100%)'
  },
  {
    date: 'Sep-22 Present',
    year: '2022-23',
    position: 'Chairperson',
    description: '',
    image: acm,
    align: 0,
    company: 'Pradnyan ACM Chapter',
    color:
      'linear-gradient(90deg, rgba(82,190,247,1) 0%, rgba(14,77,141,1) 100%)'
  }
];
